import HorizonUnitHOC from "./HorizonUnitHOC";
import HorizonUnit from "./HorizonUnit";

export { HorizonUnitHOC as HorizonUnitHOC };
export default HorizonUnit;
